import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-way',
  templateUrl: './show-way.component.html',
  styleUrls: ['./show-way.component.scss'],
})
export class ShowWayComponent implements OnInit {
  way = '';

  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    const admin = await this.db.doc$('master/masterInfo').pipe(take(1)).toPromise();
    this.way = admin.termsInfo.way;
  }
}
